const DIFF_IN_DAYS = 7; // 14
const FIRST_SHOW_DASHBOARD_OPENS = 20;
const FIRST_SHOW_HOURS_PASSED = 8;


const isFrequencyLimited = () => {
    try {
        let storageKey = "lastReviewRequested";

        if (!localStorage.getItem(storageKey)) return false;

        const now = Date.now();
        const lastReviewRequested = parseInt(localStorage.getItem(storageKey), 10);
        const diffInDays = Math.floor((now - lastReviewRequested) / 1000 / 60 / 60 / 24);

        return diffInDays < DIFF_IN_DAYS;
    } catch (e) {
        console.error(e);
        window.captureException(e);
        return true;
    }
}

export const logReviewRequested = () => {
    localStorage.setItem('lastReviewRequested', `${Date.now()}`);
}

export const isReviewDue = () => {
    try {
        if (localStorage.getItem('lastReviewSubmitted') !== null) return false;

        const appDashboardOpenCounter = localStorage.getItem('appDashboardOpenCounter') || 0;

        // At least FIRST_SHOW_DASHBOARD_OPENS number of home views must have before automatically show
        if (appDashboardOpenCounter < FIRST_SHOW_DASHBOARD_OPENS) return false;

        // At least FIRST_SHOW_HOURS_PASSED hrs must have passed before automatically show
        if(Date.now() - (FIRST_SHOW_HOURS_PASSED * 60 * 60 * 1000) < parseInt(localStorage.getItem('firstRunTS'))) return false;

        return !isFrequencyLimited();
    } catch (e) {
        console.error(e);
        window.captureException(e);
        return false;
    }
}
